import { Injectable } from '@angular/core';
import { IParameterService } from 'projects/common/src/app/interfaces/parameter-service';
import { Observable } from 'rxjs';
import { ISession } from 'projects/common/src/app/interfaces/authentication';

@Injectable({
  providedIn: 'root'
})
export class TokenService implements IParameterService<ISession> {
  name: string;
  init: () => Promise<any>;
  start: () => Promise<ISession>;
  get: () => ISession;
  getAsync: (maxAwait?: number) => Promise<ISession>;
  set: (arg0: ISession) => void;
  getObservable: () => Observable<ISession>;
  isAlreadyStarted: () => boolean;
  hasValue: () => boolean;
  bindTo: (source: Observable<any>) => void;
  startWhen: (source: Observable<any>) => void;
}
